<template>
  <span>
    <span
      v-html="formattedValue"
      :id="id"
    />
    <b-tooltip
      v-if="showTooltip"
      :placement="placement"
      :target="id"
    >
      <span v-html="tooltipValue"/>
    </b-tooltip>
  </span>
</template>

<script>
import { getUniqueId } from '@/services/createId';
import exponentialFilter,
{
  checkNumberIsValidForScientificNotation,
}
from '@/filters/exponentialFilter';

export default {
  name: 'Number',
  props: {
    value: {
      type: Number,
    },
    numberFormatOptions: {
      type: Object,
    },
    tooltipFormatOptions: {
      type: Object,
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    fallbackValue: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    id: getUniqueId(),
  }),
  computed: {
    showTooltip() {
      return this.isExponential || !!this.tooltipFormatOptions;
    },
    isExponential() {
      return checkNumberIsValidForScientificNotation(this.value);
    },
    formattedValue() {
      if (this.value === undefined || this.value === null) {
        return this.fallbackValue;
      }
      if (this.isExponential) {
        return exponentialFilter(this.value, 2);
      }
      return this.$n(this.value, this.numberFormatOptions);
    },
    tooltipValue() {
      if (this.isExponential) {
        return exponentialFilter(this.value, 10);
      }
      return this.$n(this.value, this.tooltipFormatOptions);
    },
  },
};
</script>
